import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  ListItemIcon,
  Button,
  DialogActions,
} from "@mui/material";
import { db } from "../firebase-config";
import { collection, getDocs } from "firebase/firestore";

const CompanySelectPopup = ({ open, onClose, onSelectCompany, selectedCompanies }) => {
  const [companies, setCompanies] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      const companiesRef = collection(db, "companies");
      const snapshot = await getDocs(companiesRef);
      const companyList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCompanies(companyList);
    };

    if (open) {
      fetchCompanies();
      setSelected(selectedCompanies || []);
    }
  }, [open, selectedCompanies]);

  const toggleSelect = (company) => {
    setSelected((prev) =>
      prev.some((c) => c.id === company.id)
        ? prev.filter((c) => c.id !== company.id)
        : [...prev, company]
    );
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Select Companies</DialogTitle>
      <DialogContent>
        <List>
          {companies.map((company) => (
            <ListItem
              key={company.id}
              button
              onClick={() => toggleSelect(company)}
            >
              <ListItemIcon>
                <Checkbox checked={selected.some((c) => c.id === company.id)} />
              </ListItemIcon>
              <ListItemText primary={company.name || "No Name"} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={() => {
            onSelectCompany(selected);
            onClose();
          }}
          color="primary"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompanySelectPopup;
